import { AttachedFilesText } from "constants/text.ts";
import { CustomQuoteAttachedFiles } from "./CustomQuotesAttachments.styles.ts";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import useAttachments from "hooks/useAttachments.ts";
import ImageIcon from "@mui/icons-material/Image";

interface CustomQuoteAttachmentProps {
	attachmentUrls?: string[] | null;
	quoteId?: string | null;
}

export const CustomQuoteAttachments = ({ attachmentUrls, quoteId }: CustomQuoteAttachmentProps) => {
	const { attachmentsWithUrls } = useAttachments({
		containerId: quoteId ?? "",
		attachmentUrls: attachmentUrls ?? []
	});
	return (
		<>
			{attachmentsWithUrls && attachmentsWithUrls.length > 0 && (
				<CustomQuoteAttachedFiles data-testid="custom-quote-attached-files">
					<div>{AttachedFilesText}</div>
					{attachmentsWithUrls.map((attachment, idx) => {
						const FileIcon = attachment.isPdf ? PictureAsPdfIcon : ImageIcon;
						return (
							<div key={attachment.url}>
								<div>
									<FileIcon fontSize="large" />
									<div>
										<div>{attachment.fileName}</div>
									</div>
								</div>
								<div>
									<IconButton
										role="button"
										LinkComponent="a"
										href={attachment.blobUrl || "#"}
										download={attachment.blobUrl ? attachment.fileName : undefined}
										disabled={!attachment.blobUrl}
										target="_blank"
										data-testid={`comment-attachment-download-button-${idx}`}
									>
										<DownloadIcon />
									</IconButton>
								</div>
							</div>
						);
					})}
				</CustomQuoteAttachedFiles>
			)}
		</>
	);
};
